import { useEffect, useState } from "react";
import React from "react";
import { useDispatch } from "react-redux";
import { archivarTodas, desarchivarNotificacion, fetchNotificaciones } from "../../../../redux/features/notificaciones";
import { toast } from "react-toastify";
import { API_NOTIFICACIONES } from "../shared/services/notificaciones";
import './notificaciones.scss';
import { useNavigate } from "react-router-dom";
import { API_WHATSAPP } from "../shared/services/whatsapp";
import ConfirmModal from "../shared/components/ConfirmModal";
import { setErrorMessage } from "../shared/helpers/functionalities";
import NotificacionItem from "./components/NotificacionItem";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Pagination, Tab } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import User from "../../../../models/user";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export default function Notificaciones({
  notificaciones,
  onArchived
}) {
  const { keycloak } = useKeycloak();
  const user = new User(keycloak.token, keycloak.tokenParsed)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tab, setTab] = useState('notificaciones');
  const [pages, setPages] = useState({ activas: 1, archivadas: 1 });
  const [loading, setLoading] = useState({
      activas: false,
      archivadas: false,
  });
  const [isOpenSendWhatsapp, setIsOpenSendWhatsapp] = useState(false);
  const [currentNotificacion, setCurrentNotificacion] = useState(null);
  const webSocketChannel = `notifications.${user.id}`;

  const activas = notificaciones.activas;
  const archivadas = notificaciones.archivadas;
  
  useEffect(() => {
    //connectWebSocket();
    if (!activas.loaded) loadData('activas', pages.activas);


    const interval = setInterval(() => {
      loadData('activas', pages.activas);
    }, 180000);

    return () => {
      clearInterval(interval);
      //window.Echo.leave(webSocketChannel);
    }
  }, []);

  /*const connectWebSocket = () => {
    window.Echo.private(webSocketChannel)
      .listen('.NotificacioneCreated', async (e) => {
          dispatch(fetchNotificaciones());
      });
  }*/

  const loadData = async (tipo, page) => {
      setLoading((prev) => ({ ...prev, [tipo]: true }));
      try {
          await dispatch(fetchNotificaciones({ tipo, page }));
      } catch (e) {
          toast.error(setErrorMessage(e));
      } finally {
          setLoading((prev) => ({ ...prev, [tipo]: false }));
      }
  };

  const handleChangeTab = (e, value) => {
      setTab(value);
      const tipo = value === 'archivadas' ? 'archivadas' : 'activas';
      loadData(tipo, pages[tipo]);
  };

  const handleChangePage = (event, value) => {
    const tipo = tab === "notificaciones" ? "activas" : "archivadas";

    setPages(prev => ({ ...prev, [tipo]: value }));

    loadData(tipo, value);
  }; 

  const handleArchive = async(notificacion, archived) => {
    setLoading((prev) => ({ ...prev, activas: true }));
    const response = await API_NOTIFICACIONES.archivarNotificacion(notificacion, archived);
    setLoading((prev) => ({ ...prev, activas: false }));

    if(response?.success) {
      toast.success(response.message);
      const tipoActual =
          tab === 'notificaciones' ? 'activas' : 'archivadas';
      if(tipoActual === 'archivadas') {
        dispatch(desarchivarNotificacion());
      }
      loadData(tipoActual, pages[tipoActual]);
      onArchived();
    }
  }

  const handleArchiveAll = async() => {
    setLoading((prev) => ({ ...prev, activas: true, archivadas: true }));
    const response = await API_NOTIFICACIONES.archivarAllNotificaciones();
    setLoading((prev) => ({ ...prev, activas: false, archivadas: false }));

    if(response?.success) {
      toast.success(response.message);
      setPages({
          activas: 1,
          archivadas: 1,
      });

      const tipoActual =
          tab === 'notificaciones' ? 'activas' : 'archivadas';
      if(tipoActual === 'archivadas') {
        dispatch(archivarTodas());
      }

      loadData(tipoActual, 1);
      onArchived();
    }
  }

  const handleGoTo = (item, search) => {
    dispatch({type: "search/set", payload: {search: search }});

    if(item === 'presupuesto') {
      navigate('/presupuestos/1', { replace : true});
    } else if(item === 'venta'){
      navigate('/ventas/1', { replace : true});
    } else if(item === 'devolucion'){
      navigate('/devoluciones/1', { replace : true});
    } else if(item === 'incidencia'){
      navigate('/incidencias/1', { replace : true});
    }
  }

  const handleOpenConfirmSendWhatsapp = (notificacion) => { 
    setIsOpenSendWhatsapp(true); 
    setCurrentNotificacion(notificacion);
  }
  const handleCloseConfirmSendWhatsapp = () => { 
    setIsOpenSendWhatsapp(false); 
    setCurrentNotificacion(null);
  }

  const sendWhatsAapp = async(confirm) => {
    dispatch({type: 'loading/set', payload: true});
    let tipo;

    if(confirm) {
      if(currentNotificacion.mensaje.includes('Comprobante pendiente')) {
        tipo = 'comprobante';
      } else if(currentNotificacion.mensaje.includes('Presupuesto pendiente')) {
        tipo = 'presupuesto';
      }

      const response = await API_WHATSAPP.enviarWhatsAppRecordatorio({
        tipo: tipo,
        notificacion_id: currentNotificacion.id,
        presupuesto_id: currentNotificacion.presupuesto_id
      }).catch(function (error) {
        toast.error(setErrorMessage(error))
        dispatch({type: 'loading/set', payload: false});
      });
  
      if(response && response.success) {
        dispatch({type: 'loading/set', payload: false});
        toast.success('WhatsApp enviado al cliente correctamente!')
      }
    }
    
    handleCloseConfirmSendWhatsapp();
  }

  const getPaginationCount = (tipoData) => {
        const total = tipoData?.total_items ?? 0;
        return total <= 10 ? 1 : Math.ceil(total / 10);
    };

    const renderList = (tipoData, tipo) => {
        if (loading[tipo])
            return <p className="text-center mt-3">
              <FontAwesomeIcon icon={faSpinner} size="1x" className="px-5" spin />
            </p>;
        if (!tipoData.loaded || tipoData.data.length === 0)
            return <p className="text-center mt-3">No hay notificaciones.</p>;

        return (
            <>
                {tipoData.data.map((n) => (
                    <NotificacionItem
                        key={`${tipo}-${n.id}`}
                        notificacion={n}
                        archivadas={tipo === 'archivadas'}
                        onArchive={handleArchive}
                        onGoTo={handleGoTo}
                        onSendWhatsapp={handleOpenConfirmSendWhatsapp}
                    />
                ))}
                <div className="d-flex justify-content-center mt-3">
                    <Pagination
                        className="mt-3"
                        count={getPaginationCount(tipoData)}
                        page={pages[tipo]}
                        onChange={handleChangePage}
                    />
                </div>
            </>
        );
    };

    return (
        <div className="w-100 d-flex flex-column">
            <div className="w-100 d-flex align-items-center justify-content-start mb-3">
                <button
                    type="button"
                    className="btn btn-info"
                    onClick={handleArchiveAll}
                >
                    Archivar
                </button>
            </div>

            <TabContext value={tab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChangeTab} aria-label="Ajustes">
                        <Tab label="Notificaciones" value="notificaciones" />
                        <Tab label="Archivadas" value="archivadas" />
                    </TabList>
                </Box>

                <TabPanel value="notificaciones">
                    {renderList(activas, 'activas')}
                </TabPanel>

                <TabPanel value="archivadas">
                    {renderList(archivadas, 'archivadas')}
                </TabPanel>
            </TabContext>
      

      { isOpenSendWhatsapp && 
        <ConfirmModal
            onConfirmAction={sendWhatsAapp} 
            onClose={handleCloseConfirmSendWhatsapp}
            title={'WhatsApp de recordatorio'} 
            description={'Estás seguro de enviar un WhatsApp de recordatorio al cliente?'}
            state={isOpenSendWhatsapp}>
        </ConfirmModal>
      }
    </div>
  );
  
}